import React from 'react';

import ArrowTooltipCss from '../../ArrowTooltipCss';

import AnimatedButton from '../../AnimatedSavingBtn';
import SetDeleteTrplBtns from './SetDeleteTrplBtns';
import MandatoryAlertIcon from './MandatoryAlertIcon';
import { savedTrplColor } from '../../../constants';
import { downloadFile } from '../../../utils';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import SignTrpl from './SignTrpl';

export default ({
  rst,
  trpls,
  type,
  setTrpl,
  classes,
  groupId,
  constant,
  ancestorId,
  loadingTids,
  isAnotherNode,
  setLoadingTids,
  removeTrplValue,
  disableTrplEditing,
  showMandatoryAlert,
  toggleUploadImgModal,
}) => {

  // Links format: https://kappertest.s3.amazonaws.com/trpls/oxoqekjagv.jpg
  const getImageMiniatureUrl = (metadataVal) => `${metadataVal.path}/trpls32/${metadataVal.name}`;

  const isSignature = rst && rst.render_widget === 'signature';

  return (
    <React.Fragment>
      {trpls.map((trpl, trplIndex) => (
        <div style={{ height: '24px' }} key={`${rst.title}.${trplIndex}`} className={`${classes.spaceBetween} ${trplIndex === 0 ? '' : classes.mt5}`}>
            {isSignature && !trpl.tid ?
              <SignTrpl
                rst={rst}
                type={type}
                trpl={trpl}
                setTrpl={setTrpl}
                constant={constant}
                ancestorId={ancestorId}
                loadingTids={loadingTids}
                isAnotherNode={isAnotherNode}
                setLoadingTids={setLoadingTids}
                removeTrplValue={removeTrplValue}
                showMandatoryAlert={showMandatoryAlert}
                disableTrplEditing={disableTrplEditing}
              />
            : trpl.tid && trpl.metadata && trpl.metadata._val && 
              <div
                className={`${classes.alignCenter} ${classes.fw} ${classes.trplFileLinkContainer}`}
                style={{
                  fontSize: '12px',
                  overflow: 'auto',
                  padding: `${trpl.metadata._val.is_img ? '0px' : '4px 5px 3px'}`,
                  background: savedTrplColor //'#ddeed59e',//'#f2eee1',
                }}
              >
                {trpl.metadata._val.is_img && (
                  <img width="24" height="24" src={getImageMiniatureUrl(trpl.metadata._val)} className={classes.mr10} alt="trpl-img" />
                )}

                <a target="_blank" rel="noreferrer" href={trpl.metadata._val.url} className={classes.trplFileLink}>
                  {trpl.metadata._val.src_name}
                </a>
              </div>
              }

          {trpl.tid && trpl.metadata && !trpl.metadata._val && (
            <div className={classes.notValidFileTrpl}>Not valid file</div>
          )}

          {trpl.tid && trpl.metadata && trpl.metadata._val && (
            <div
              className={`${classes.btnDownload} ${classes.ml10} ${classes.flex}`}
              onClick={() => {
                downloadFile(trpl.metadata._val.url, trpl.metadata._val.src_name, true)
              }}
            >
              <ArrowTooltipCss text="Download">
                <CloudDownloadOutlinedIcon/>
              </ArrowTooltipCss>
            </div>
          )}

          {!trpl.tid && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {isSignature ? null :
                <div className={classes.alignCenter}>
                  <AnimatedButton
                    disabled={constant || disableTrplEditing}
                    onClick={() => {
                      toggleUploadImgModal(
                        true,
                        {
                          action: 'TRIPLE_FILE',
                          eid: ancestorId,
                          pid: rst.id,
                        },
                        rst,
                      );
                    }}
                  >
                    <span>Upload</span>
                  </AnimatedButton>

                  {showMandatoryAlert && <MandatoryAlertIcon/>}
                </div>
              }

            </div>
          )}

          {trpl.tid ?
            <SetDeleteTrplBtns
              rst={rst}
              type={type}
              trpl={trpl}
              groupId={groupId}
              classes={classes}
              setTrpl={setTrpl}
              trplIndex={trplIndex}
              ancestorId={ancestorId}
              loadingTids={loadingTids}
              isAnotherNode={isAnotherNode}
              setLoadingTids={setLoadingTids}
              removeTrplValue={removeTrplValue}
              constant={constant || disableTrplEditing}
            />
          : null}
        </div>
        )
      )}
    </React.Fragment>
  );
};
